module.exports = __webpack_public_path__ + "media/images/mobile/dummy08-5d9c63d54939f2fa9d2780c06cd5a3f5.jpg";